import React, { useEffect, useState } from "react";
import styles from "./index.module.css";

import Posenet from "../../components/Posenet";

const MAX_WIDTH = 375;

const Page = ({ onScore, onRestart }) => {
  const [restarting, setRestarting] = useState(false);
  const [score, setScore] = useState(0);
  const [phase, setPhase] = useState("");
  const [dims, setDims] = useState({ height: 0, width: 0 });
  useEffect(() => {
    // didmount
    console.log("mounted this page yo");
    setDims({
      height: window.innerHeight,
      width: Math.min(window.innerWidth, MAX_WIDTH)
    });

    // show modal, prepare user to start
    setPhase("start");

    return () => console.log("unmounted this page yo");
  }, []);

  const handleClick = type => {
    if (type === "start") {
      setPhase("play");
      setRestarting(false);
    } else if (type === "endless") {
      setPhase("endless");
      setRestarting(false);
    } else if (type === "end") {
      setPhase("submit");
      setRestarting(true);
      if (onScore) {
        onScore(score);
      }
    } else if (type === "retry") {
      setRestarting(true);
      if (onRestart) {
        onRestart();
      }
    }
  };

  // handles live recording of pose
  const onTracePose = p => {};

  const onTraceVideo = v => {
    //console.log(v)
  };

  // when one loop ends, trigger this
  const handleRecordEnd = score => {
    console.log("SCORE IS");
    console.log(score);
    setScore(score);
    setPhase("end");
  };

  const Modal = ({ type, onClick, score }) => {
    if (type === "start") {
      return (
        <div className={styles.modalStart}>
          <p>Ready to go?</p>
          <button onClick={() => onClick(type)}>START!</button>
          <br />
          <button onClick={() => onClick("endless")}>ENDLESS MODE!</button>
        </div>
      );
    } else if (type === "end") {
      return (
        <div className={styles.modalEnd}>
          <p>your score is {score}</p>
          <p>do you want to submit?</p>
          <button onClick={() => onClick("retry")}>RETRY</button>
          <button onClick={() => onClick(type)}>SUBMIT</button>
        </div>
      );
    } else if (type === "play" || type === "endless") {
      return (
        <Posenet
          restart={restarting}
          onEnd={handleRecordEnd}
          videoWidth={dims.width}
          videoHeight={dims.height}
          mobileNetArchitecture={0.5}
          outputStride={8}
          loadingText={"Loading..."}
          frontCamera={true}
          getPoseRecords={onTracePose}
          getVideoRecords={onTraceVideo}
          showVideo={true}
          algorithm={"single-pose"}
          record={true}
          recordVideo
          endless={type === "endless" ? true : false}
        />
      );
    } else {
      return null;
    }
  };

  return (
    <div className={styles.page}>
      <Modal type={phase} onClick={handleClick} score={score} />
    </div>
  );
};

export default Page;
